// extracted by mini-css-extract-plugin
module.exports = {"container":"TableEmptyState_container__JfiZN","icon":"TableEmptyState_icon__jJauj","description":"TableEmptyState_description__u1zJu"};